import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { MARGIN_PADD_02, POS_AB_RT_8 } from "../../../utils/GlobalConstants";

const DialogView = (props) => {
  return (
    <Dialog
      onClose={props.handleClose}
      aria-labelledby="customized-dialog-title"
      open={props.open}
      sx={props.style}
      PaperProps={{
        sx: {
          width: props.width ? props.width : "100%",
          maxWidth: props.maxWidth ? props.maxWidth : "65em!important",
          p: 0,
          m: 0,
          backgroundColor: props.background,
        },
      }}
    >
      <DialogTitle sx={MARGIN_PADD_02} id="customized-dialog-title">
        {props.heading}
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={props.handleClose}
        sx={POS_AB_RT_8}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers children={props.childComponet} />
    </Dialog>
  );
};

export default DialogView;
